<template>
  <div v-if="service">
    <v-toolbar class="mb-3" elevation="0">
      <v-toolbar-title>Service "{{service.name}}" > Builder</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="addStep">Ajouter une étape</v-btn>
    </v-toolbar>
    <v-card elevation="0" v-if="service.steps.length>0">
      <v-toolbar elevation="1">
        <v-toolbar-title>Step {{currentStep+1}} - {{service.steps[currentStep].name}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon :disabled="currentStep==0" @click="previousStep">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-dialog v-model="editStep" max-width="980px">
          <template v-slot:activator="{on}">
            <v-btn icon v-on="on">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-toolbar>
              <v-toolbar-title>Modifier l'étape</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-container>
                  <v-row>
                    <v-col>
                      <v-text-field
                        v-model="service.steps[currentStep].name"
                        label="Nom de l'étape"
                      />
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-btn text @click="editStep=false">Annuler</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="update()">Sauver</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-btn @click="deleteStep()" icon>
          <v-icon>mdi-delete</v-icon>
        </v-btn>
        <v-btn icon v-if="currentStep<service.steps.length-1" @click="nextStep()">
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
        <v-btn icon v-else @click="addStep">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-container fluid>
          <step :step="service.steps[currentStep]" :key="service.steps[currentStep].id" />
        </v-container>
      </v-card-text>
      <v-card-actions></v-card-actions>
    </v-card>
    <v-card elevation="0" v-else>
      <v-card-text>
        <v-container>
          <v-row align="center" justify="center">
            <v-col cols="3">
              <v-btn color="primary" @click="addStep">Ajouter une étape</v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
    <v-dialog v-model="stepForm" persistent max-width="980px">
      <v-card>
        <v-toolbar>
          <v-toolbar-title>Ajouter une étape</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-container>
              <v-row>
                <v-col>
                  <v-text-field v-model="step.name" label="Nom de l'étape" />
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="cancel()">Annuler</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="save()">Sauver</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Step from "@/components/services/builder/Step.vue";
export default {
  components: {
    Step
  },
  data: function() {
    return {
      serviceId: null,
      service: null,
      currentStep: 0,
      stepForm: null,
      valid: false,
      step: {
        name: null
      },
      editStep: false
    };
  },
  mounted: function() {
    this.initialize();
  },
  beforeDestroy() {
    this.$store.dispatch("services/cleanService").then(() => {
      this.$store.dispatch("services/setCurrentService", null);
    });
  },
  methods: {
    initialize() {
      if (this.$route.params.id) {
        this.currentStep = 0;
        this.serviceId = parseInt(this.$route.params.id);
        this.getService();
      } else {
        this.$router.push("/services");
      }
    },
    getService() {
      this.$store.dispatch("services/get", this.serviceId).then(() => {
        this.service = this.$store.getters["services/service"];
        this.$store.dispatch("services/setCurrentService", this.service);
      });
    },
    update() {
      this.$store
        .dispatch("step/update", {
          serviceId: this.service.id,
          stepId: this.service.steps[this.currentStep].id,
          model: this.service.steps[this.currentStep]
        })
        .then(() => {
          this.editStep = false;
          //this.initialize();
        });
    },
    save() {
      this.$store
        .dispatch("step/create", { serviceId: this.serviceId, step: this.step })
        .then(() => {
          this.cancel();
          this.initialize();
        });
    },
    addStep() {
      this.stepForm = true;
    },
    cancel() {
      this.step.name = null;
      this.stepForm = false;
    },
    nextStep() {
      if (this.currentStep + 1 <= this.service.steps.length - 1) {
        this.currentStep++;
      }
    },
    previousStep() {
      if (this.currentStep - 1 >= 0) {
        this.currentStep--;
      }
    },
    deleteStep() {
      confirm("Etes-vous sûre cette étape ?") &&
        this.$store
          .dispatch("step/delete", {
            serviceId: this.service.id,
            stepId: this.service.steps[this.currentStep].id
          })
          .then(() => {
            this.initialize();
          });
    }
  }
};
</script>

<style>
</style>